import CoverageMapComponent from "./CoverageMapComponent.tsx";
import {MapRegion} from "./CoverageMap.ts";
import CoverageChoiceComponent from "./CoverageChoiceComponent.tsx";
import {useState} from "react";

export default function CoverageMapContainer(props: { regionPreset: MapRegion, fiberMapOnly: boolean, static: boolean }) {
    const [region, setRegion] = useState<MapRegion>(props.regionPreset);

    return (
        <div className={`coverage-map-container ${props.fiberMapOnly ? 'fiber-only' : ''}`}>
            <CoverageChoiceComponent
                fiberMapOnly={props.fiberMapOnly}
                activeRegion={region}
                setActiveRegion={setRegion}
                static={props.static}
            />
            <CoverageMapComponent region={region}/>
        </div>
    )
}
